/**
 * Реферальная программа B2B: владелец приглашает владельца, награда — бесплатные дни подписки.
 *
 * Числа живут ТОЛЬКО здесь: бэкенд начисляет по ним, фронт рисует из них строку условий.
 * Второй экземпляр «7» в разметке разойдётся с бэкендом в день, когда условия поменяют.
 */

export const REFERRAL = {
  /** Приглашённый — мастер-одиночка (`businesses.is_solo`). */
  rewardDaysSolo: 7,
  /** Приглашённый — организация с командой. */
  rewardDaysTeam: 14,
  /**
   * Потолок на реферера: сколько приглашений он может наградить. Считаем приглашения, а не
   * дни: «10 приглашений» владелец понимает сразу, а потолок в днях зависел бы от смеси
   * одиночек и команд и упирался бы в половинчатую последнюю награду. Худший случай —
   * 10 × 14 = 140 дней, меньше полугода бесплатной подписки на одного реферера.
   * Сверх потолка приглашённый работает как обычно, награда просто не начисляется.
   */
  maxRewardedInvites: 10,
} as const;

/** Префикс payload в `t.me/<бот>?start=ref_<код>` и `?startapp=ref_<код>`. Не пересекается с `src_`. */
export const REFERRAL_PAYLOAD_PREFIX = 'ref_';

/** Сколько дней получает реферер: по `isSolo` организации приглашённого и больше ни по чему. */
export function referralRewardDays(isSolo: boolean): number {
  return isSolo ? REFERRAL.rewardDaysSolo : REFERRAL.rewardDaysTeam;
}

/**
 * Ссылка-приглашение. Код случайный и короткий; `tg_id` реферера в ссылку не попадает никогда.
 *
 * `startapp`, а не `start`: со `start` Telegram открывал чат бота, и приглашённый должен был
 * ещё нажать «Запустить». `startapp` открывает Mini App сразу, а метку забирает `POST /api/session`
 * из `start_param` (см. `buildApp.ts`). Требует включённого Main Mini App в BotFather —
 * без него Telegram по обеим формам ссылки открывает просто чат (см. `deploy/README.md`).
 */
export function referralLink(botUsername: string, code: string): string {
  return `https://t.me/${botUsername.replace(/^@/, '')}?startapp=${REFERRAL_PAYLOAD_PREFIX}${code}`;
}

/** `start_param` Mini App похож на реферальный код, а не на slug заведения (slug не содержит `_`). */
export function isReferralStartParam(raw: string | undefined): boolean {
  return raw !== undefined && raw.startsWith(REFERRAL_PAYLOAD_PREFIX);
}

/**
 * `start_param` — это МЕТКА, а не slug заведения: реферал `ref_…` или источник `src_…`.
 * Признак — подчёркивание: slug состоит из `[a-z0-9-]` и `_` не содержит (`domain/slug.ts`).
 *
 * По этому фронт решает, открывать ли заведение по `?startapp=…`: метку на входе разбирает
 * сервер (`POST /session` зовёт и `recordReferral`, и `recordAcquisitionSource`), а открывать
 * «заведение ref_/src_…» нельзя — такого slug нет, был бы экран «не найдено».
 */
export function isLabelStartParam(raw: string | undefined): boolean {
  return raw !== undefined && raw.includes('_');
}
